import React, { useContext, useState, useMemo } from 'react';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { PageTitle } from 'components/layouts/pageTitle';
import { Config } from 'configs';
import { files } from 'codemash';
import { FormButton } from 'components/buttons/formButton';
import { CheckboxWrapper } from 'components/formInputs/wrappers/checkboxWrapper';
import { DropdownWrapper } from 'components/formInputs/wrappers/dropdownWrapper';
import { defaultLanguageCodes } from 'views/restaurants/general';
import { ImageUpload } from 'components/formInputs/imageUpload';
import { apiActionChooser } from 'utils/apiActionChooser';
import { postFile } from 'api/client/requests';

export const ProductsImportExportEditForm = () => {
  const navigate = useNavigate();

  const { addNew } = useContext(CompanyContext);
  const { state: auth } = useContext(AuthContext);

  const [importFile, setImportFile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isImport, setIsImport] = useState(false);

  const schema = yup.object().shape({
    language_code: yup.string().required('Language required').default(''),
    is_import: yup.boolean().default(false),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => {
      return schema.default();
    }, [schema]),
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setLoading(true);

    const submitData = {
      company: auth.company?.company,
      is_import: data.is_import,
      language_code: data.language_code,
    };

    if (data.is_import) {
      if (
        importFile &&
        importFile.length > 0 &&
        importFile[0].file !== null &&
        importFile[0].file !== undefined
      ) {
        await apiActionChooser(
          auth.company?.company,
          async () => {
            const fileResp = await files.uploadRecordFile({
              collectionName: Config.DATA.COLLECTIONS.PRODUCT_SHEET_IMPORTS,
              database: Config.CODEMASH.DATABASE_ID,
              uniqueFieldName: 'file',
              secretKey: auth.token,
              file: importFile[0].file,
            });

            submitData.file = [fileResp.key];
          },
          async () => {
            const fileResp = await postFile({
              fieldPath: 'file',
              file: importFile[0].file,
              resource: 'ProductSheetImports',
            });

            submitData.file = fileResp.id;
          },
        );
      }

      /*
      if (!submitData.file || submitData.file.length === 0 || !submitData.file[0]) {
        setLoading(false);
        return;
      }
        */
    }

    await addNew(
      {
        collectionName: Config.DATA.COLLECTIONS.PRODUCT_SHEET_IMPORTS,
        data: submitData,
        token: auth.token,
        resourceV2: 'AdminProductSheetImport',
        companyIdForV2: auth.company?.company,
      },
      async () => {
        navigate('/products/imports');
        setLoading(false);
      },
      () => {
        setLoading(false);
      },
    );
  };

  const onError = (data) => console.log(data);

  return (
    <>
      <PageTitle
        title="Products Import / Export"
        breadcrumbs={[
          { path: '/products', title: 'Products' },
          { path: '/products/imports', title: 'Products imports' },
        ]}
      />
      <div className="container mx-auto px-2 md:px-6 lg:px-8">
        <div className="w-full">
          <form onSubmit={handleSubmit(onSubmit, onError)} action="#" method="POST">
            <div className="shadow sm:rounded-md sm:overflow-hidden">
              <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">Add new</h3>
                </div>

                <div className="grid grid-cols-6 gap-6">
                  <div className="col-span-6 lg:col-span-3">
                    <CheckboxWrapper
                      register={register}
                      name="is_import"
                      title="Is Import"
                      subtitle="it is recommended to first export to get latest changes before updating"
                      responsiveClassName="w-full"
                      onChange={(e) => {
                        setIsImport(e.target.checked);
                      }}
                    />
                  </div>

                  <div className="hidden lg:block lg:col-span-3" />

                  <div className="col-span-6 lg:col-span-3">
                    <DropdownWrapper
                      register={register}
                      name="language_code"
                      title="Language"
                      subtitle="only 1 language can be imported / exported at a time"
                      options={defaultLanguageCodes}
                      error={errors?.language_code}
                    />
                  </div>

                  <div className="hidden lg:block lg:col-span-3" />

                  {isImport && (
                    <div className="col-span-6 lg:col-span-3">
                      <label className="block text-sm font-medium text-gray-700">
                        Import file (.xlsx)
                      </label>
                      <ImageUpload
                        id="importFile"
                        name="importFile"
                        images={importFile}
                        onChange={(val) => setImportFile(val)}
                        isNotImage
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                <button
                  type="button"
                  className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  onClick={() => navigate('/products/imports')}
                  disabled={loading}
                >
                  Cancel
                </button>
                <FormButton text="Save" isLoading={loading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
